export const organizationCalendarBox = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  my: '0.5rem',
  fontSize: '0.8rem',
  fontWeight: 600,
  whiteSpace: 'nowrap',
};
export const organizationCalendarStatus = {
  color: 'var(--paper)',
  px: 1,
  py: 0.75,
  borderRadius: 0.5,
};
